const selectAddMember = state => {
  return {
    ...state.loyalty
  };
};

const selectReferences = state => {
  return {
    ...state.loyalty.references
  };
};

export { selectAddMember, selectReferences };
